import { useCallback } from 'react'
import { usePeopleMe } from '../../../team/useTeam'
import { canOpenHealth } from './health'

/**
 * Nateva's per-person tab visibility. The Health tab is for admins only (who are not seeing it as someone
 * else); every other tab shows exactly as before. undefined = not known yet, so Health stays out of the menu
 * until the database has said who the person is. The database refuses the health calls to anyone else too.
 */
export function useNatevaVisibility(): (id: string) => boolean | undefined {
  const q = usePeopleMe()
  const me = q.data
  const known = q.isSuccess || q.isError
  return useCallback(
    (id: string) => {
      if (id !== 'health') return true
      if (!known) return undefined
      return canOpenHealth(me)
    },
    [known, me],
  )
}
